<template>
    <Card >
        <template #content>
            <h2 class="text-black dark:text-white"><slot></slot></h2>
        </template>
    </Card>
</template>